import { useMutation } from "@tanstack/react-query";
import api from "../../../../api";
import urls from "../../../../urls";
import { pollTaskStatus } from "../../../../utils/api-utils";

interface MaStRGeneratorImportInput {
  mastr_nummer: string;
  person: number;
  site: number;
}

export function useMaStRGeneratorMutation() {
  return useMutation({ mutationFn: importGeneratorsFromMaStR });
}

async function importGeneratorsFromMaStR(
  data: MaStRGeneratorImportInput
): Promise<string> {
  const response = await api.post<{
    taskStatusUrl: string;
    taskIds: Array<string>;
  }>(urls.api.importGeneratorsFromMastr(), data);
  const { taskStatusUrl, taskIds } = response.data;

  return new Promise<string>((resolve, reject) => {
    void pollTaskStatus(
      taskStatusUrl,
      () => resolve(taskIds[0]),
      (error) => reject(error)
    );
  });
}
